var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[_c('img',{staticClass:"image_4",attrs:{"referrerpolicy":"no-referrer","src":require("./assets/img/SketchPngac97280f241a820a684f88e3d1c7c959ce837fbd47d3b4cf2c2bd7ea308cc855.png")}})])
}]

export { render, staticRenderFns }